"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSitemapItems = void 0;
exports.defaultSitemapItems = [
    {
        text: 'Property Search',
        url: null,
        sitemapItems: [
            {
                text: 'Hong Kong Properties For Rent',
                url: 'https://devnew.okay.com/en/property-search/rent',
                sitemapItems: null,
            },
            {
                text: 'Hong Kong Properties For Sale',
                url: 'https://devnew.okay.com/en/property-search/buy',
                sitemapItems: null,
            },
        ],
    }, {
        text: 'Resources',
        url: null,
        sitemapItems: [{
                text: 'News & Insights',
                url: 'https://devnew.okay.com/en/property-news',
                sitemapItems: null,
            }, {
                text: 'Ask An Agent',
                url: 'https://devnew.okay.com/en/property-questions',
                sitemapItems: null,
            }, {
                text: 'Guides',
                url: null,
                sitemapItems: [{
                        text: 'Renting an Apartment in Hong Kong',
                        url: 'https://devnew.okay.com/en/property-news/renting-an-apartment-in-hong-kong/54',
                        sitemapItems: null,
                    }, {
                        text: 'Property Investment Strategy: Peter Churchouse’s 10 Key Rules',
                        url: 'https://devnew.okay.com/en/property-news/property-investment-strategy-peter-churchouses-10-key-rules/153',
                        sitemapItems: null,
                    }, {
                        text: 'A Guide to Hong Kong\'s Real Estate System and Property Tax',
                        url: 'https://devnew.okay.com/en/property-news/a-guide-to-hong-kongs-real-estate-system-and-property-tax/150',
                        sitemapItems: null,
                    }, {
                        text: 'An Overview of Special Stamp Duty, Buyer\'s Stamp Duty and Ad Valorem Stamp Duty',
                        url: 'https://devnew.okay.com/en/property-news/an-overview-of-special-stamp-duty-buyers-stamp-duty-and-ad-valorem-stamp-duty/152',
                        sitemapItems: null,
                    }, {
                        text: 'Conveyancing, Mortgages and Property Insurance in Hong Kong',
                        // tslint:disable-next-line: max-line-length
                        url: 'https://devnew.okay.com/en/property-news/conveyancing-mortgages-and-property-insurance-in-hong-kong/151',
                        sitemapItems: null,
                    }],
            }, {
                text: 'Hong Kong District Guides',
                url: null,
                sitemapItems: [{
                        text: 'Aberdeen (inc. Ap Lei Chau)',
                        url: 'https://devnew.okay.com/en/district/aberdeen/1',
                        sitemapItems: null,
                    }, {
                        text: 'Causeway Bay',
                        url: 'https://devnew.okay.com/en/district/causeway-bay/4',
                        sitemapItems: null,
                    }, {
                        text: 'Central',
                        url: 'https://devnew.okay.com/en/district/central/119',
                        sitemapItems: null,
                    }, {
                        text: 'Chai Wan',
                        url: 'https://devnew.okay.com/en/district/chai-wan/6',
                        sitemapItems: null,
                    }, {
                        text: 'Cheung Chau',
                        url: 'https://devnew.okay.com/en/district/cheung-chau/88',
                        sitemapItems: null,
                    }, {
                        text: 'Cheung Sha Wan',
                        url: 'https://devnew.okay.com/en/district/cheung-sha-wan/39',
                        sitemapItems: null,
                    }, {
                        text: 'Chung Hom Kok',
                        url: 'https://devnew.okay.com/en/district/chung-hom-kok/7',
                        sitemapItems: null,
                    }, {
                        text: 'Clearwater Bay',
                        url: 'https://devnew.okay.com/en/district/clearwater-bay/68',
                        sitemapItems: null,
                    }, {
                        text: 'Deep Water Bay',
                        url: 'https://devnew.okay.com/en/district/deep-water-bay/99',
                        sitemapItems: null,
                    }, {
                        text: 'Diamond Hill',
                        url: 'https://devnew.okay.com/en/district/diamond-hill/40',
                        sitemapItems: null,
                    }, {
                        text: 'Discovery Bay',
                        url: 'https://devnew.okay.com/en/district/discovery-bay/89',
                        sitemapItems: null,
                    }, {
                        text: 'Fanling',
                        url: 'https://devnew.okay.com/en/district/fanling/70',
                        sitemapItems: null,
                    }, {
                        text: 'Fortress Hill',
                        url: 'https://devnew.okay.com/en/district/fortress-hill/128',
                        sitemapItems: null,
                    }, {
                        text: 'Happy Valley',
                        url: 'https://devnew.okay.com/en/district/happy-valley/10',
                        sitemapItems: null,
                    }, {
                        text: 'Ho Man Tin',
                        url: 'https://devnew.okay.com/en/district/ho-man-tin/41',
                        sitemapItems: null,
                    }, {
                        text: 'Hung Hom',
                        url: 'https://devnew.okay.com/en/district/hung-hom/42',
                        sitemapItems: null,
                    }, {
                        text: 'Jardine\'s Lookout',
                        url: 'https://devnew.okay.com/en/district/jardines-lookout/127',
                        sitemapItems: null,
                    }, {
                        text: 'Jordan',
                        url: 'https://devnew.okay.com/en/district/jordan/43',
                        sitemapItems: null,
                    }, {
                        text: 'Kai Tak',
                        url: 'https://devnew.okay.com/en/district/kai-tak/124',
                        sitemapItems: null,
                    }, {
                        text: 'Kowloon Bay',
                        url: 'https://devnew.okay.com/en/district/kowloon-bay/45',
                        sitemapItems: null,
                    }, {
                        text: 'Kowloon City',
                        url: 'https://devnew.okay.com/en/district/kowloon-city/46',
                        sitemapItems: null,
                    }, {
                        text: 'Kowloon Station',
                        url: 'https://devnew.okay.com/en/district/kowloon-station/104',
                        sitemapItems: null,
                    }, {
                        text: 'Kowloon Tong',
                        url: 'https://devnew.okay.com/en/district/kowloon-tong/47',
                        sitemapItems: null,
                    }, {
                        text: 'Kwai Chung',
                        url: 'https://devnew.okay.com/en/district/kwai-chung/74',
                        sitemapItems: null,
                    }, {
                        text: 'Kwun Tong',
                        url: 'https://devnew.okay.com/en/district/kwun-tong/48',
                        sitemapItems: null,
                    }, {
                        text: 'Lai Chi Kok',
                        url: 'https://devnew.okay.com/en/district/lai-chi-kok/49',
                        sitemapItems: null,
                    }, {
                        text: 'Lam Tin',
                        url: 'https://devnew.okay.com/en/district/lam-tin/50',
                        sitemapItems: null,
                    }, {
                        text: 'Lamma Island',
                        url: 'https://devnew.okay.com/en/district/lamma-island/90',
                        sitemapItems: null,
                    }, {
                        text: 'Lantau Island',
                        url: 'https://devnew.okay.com/en/district/lantau-island/91',
                        sitemapItems: null,
                    }, {
                        text: 'Ma On Shan',
                        url: 'https://devnew.okay.com/en/district/ma-on-shan/75',
                        sitemapItems: null,
                    }, {
                        text: 'Ma Wan',
                        url: 'https://devnew.okay.com/en/district/ma-wan/92',
                        sitemapItems: null,
                    }, {
                        text: 'Mid-levels Central',
                        url: 'https://devnew.okay.com/en/district/mid-levels-central/14',
                        sitemapItems: null,
                    }, {
                        text: 'Mid-Levels East (inc. Stubbs Road)',
                        url: 'https://devnew.okay.com/en/district/mid-levels-east/15',
                        sitemapItems: null,
                    }, {
                        text: 'Mid-levels West',
                        url: 'https://devnew.okay.com/en/district/mid-levels-west/17',
                        sitemapItems: null,
                    }, {
                        text: 'Mong Kok',
                        url: 'https://devnew.okay.com/en/district/mong-kok/52',
                        sitemapItems: null,
                    }, {
                        text: 'North Point',
                        url: 'https://devnew.okay.com/en/district/north-point/18',
                        sitemapItems: null,
                    }, {
                        text: 'North Point Hill',
                        url: 'https://devnew.okay.com/en/district/north-point-hill/16',
                        sitemapItems: null,
                    }, {
                        text: 'Olympic Station',
                        url: 'https://devnew.okay.com/en/district/olympic-station/103',
                        sitemapItems: null,
                    }, {
                        text: 'Peng Chau',
                        url: 'https://devnew.okay.com/en/district/peng-chau/93',
                        sitemapItems: null,
                    }, {
                        text: 'Pokfulam',
                        url: 'https://devnew.okay.com/en/district/pokfulam/19',
                        sitemapItems: null,
                    }, {
                        text: 'Quarry Bay',
                        url: 'https://devnew.okay.com/en/district/quarry-bay/20',
                        sitemapItems: null,
                    }, {
                        text: 'Repulse Bay',
                        url: 'https://devnew.okay.com/en/district/repulse-bay/22',
                        sitemapItems: null,
                    }, {
                        text: 'Sai Kung',
                        url: 'https://devnew.okay.com/en/district/sai-kung/77',
                        sitemapItems: null,
                    }, {
                        text: 'Sai Ying Pun',
                        url: 'https://devnew.okay.com/en/district/sai-ying-pun/24',
                        sitemapItems: null,
                    }, {
                        text: 'Sham Shui Po',
                        url: 'https://devnew.okay.com/en/district/sham-shui-po/57',
                        sitemapItems: null,
                    }, {
                        text: 'Sham Tseng',
                        url: 'https://devnew.okay.com/en/district/sham-tseng/79',
                        sitemapItems: null,
                    }, {
                        text: 'Shatin',
                        url: 'https://devnew.okay.com/en/district/shatin/80',
                        sitemapItems: null,
                    }, {
                        text: 'Shau Kei Wan',
                        url: 'https://devnew.okay.com/en/district/shau-kei-wan/25',
                        sitemapItems: null,
                    }, {
                        text: 'Shek Kip Mei',
                        url: 'https://devnew.okay.com/en/district/shek-kip-mei/58',
                        sitemapItems: null,
                    }, {
                        text: 'Shek O',
                        url: 'https://devnew.okay.com/en/district/shek-o/26',
                        sitemapItems: null,
                    }, {
                        text: 'Sheung Shui',
                        url: 'https://devnew.okay.com/en/district/sheung-shui/81',
                        sitemapItems: null,
                    }, {
                        text: 'Sheung Wan',
                        url: 'https://devnew.okay.com/en/district/sheung-wan/97',
                        sitemapItems: null,
                    }, {
                        text: 'Shouson Hill',
                        url: 'https://devnew.okay.com/en/district/shouson-hill/27',
                        sitemapItems: null,
                    }, {
                        text: 'South Bay',
                        url: 'https://devnew.okay.com/en/district/south-bay/111',
                        sitemapItems: null,
                    }, {
                        text: 'Stanley',
                        url: 'https://devnew.okay.com/en/district/stanley/30',
                        sitemapItems: null,
                    }, {
                        text: 'Tai Hang',
                        url: 'https://devnew.okay.com/en/district/tai-hang/125',
                        sitemapItems: null,
                    }, {
                        text: 'Tai Po',
                        url: 'https://devnew.okay.com/en/district/tai-po/82',
                        sitemapItems: null,
                    }, {
                        text: 'Tai Tam',
                        url: 'https://devnew.okay.com/en/district/tai-tam/32',
                        sitemapItems: null,
                    }, {
                        text: 'The Peak',
                        url: 'https://devnew.okay.com/en/district/the-peak/34',
                        sitemapItems: null,
                    }, {
                        text: 'Tin Hau',
                        url: 'https://devnew.okay.com/en/district/tin-hau/129',
                        sitemapItems: null,
                    }, {
                        text: 'To Kwa Wan',
                        url: 'https://devnew.okay.com/en/district/to-kwa-wan/60',
                        sitemapItems: null,
                    }, {
                        text: 'Tseung Kwan O/Hang Hau',
                        url: 'https://devnew.okay.com/en/district/tseung-kwan-o-hang-hau/73',
                        sitemapItems: null,
                    }, {
                        text: 'Tsim Sha Tsui',
                        url: 'https://devnew.okay.com/en/district/tsim-sha-tsui/61',
                        sitemapItems: null,
                    }, {
                        text: 'Tsing Yi',
                        url: 'https://devnew.okay.com/en/district/tsing-yi/84',
                        sitemapItems: null,
                    }, {
                        text: 'Tsuen Wan',
                        url: 'https://devnew.okay.com/en/district/tsuen-wan/85',
                        sitemapItems: null,
                    }, {
                        text: 'Tuen Mun',
                        url: 'https://devnew.okay.com/en/district/tuen-mun/86',
                        sitemapItems: null,
                    }, {
                        text: 'Wan Chai',
                        url: 'https://devnew.okay.com/en/district/wan-chai/37',
                        sitemapItems: null,
                    }, {
                        text: 'Western District (inc. Kennedy Town)',
                        url: 'https://devnew.okay.com/en/district/western-district/98',
                        sitemapItems: null,
                    }, {
                        text: 'Wong Chuk Hang',
                        url: 'https://devnew.okay.com/en/district/wong-chuk-hang/115',
                        sitemapItems: null,
                    }, {
                        text: 'Wong Tai Sin',
                        url: 'https://devnew.okay.com/en/district/wong-tai-sin/64',
                        sitemapItems: null,
                    }, {
                        text: 'Yau Ma Tei',
                        url: 'https://devnew.okay.com/en/district/yau-ma-tei/65',
                        sitemapItems: null,
                    }, {
                        text: 'Yau Tong',
                        url: 'https://devnew.okay.com/en/district/yau-tong/66',
                        sitemapItems: null,
                    }, {
                        text: 'Yuen Long',
                        url: 'https://devnew.okay.com/en/district/yuen-long/87',
                        sitemapItems: null,
                    }],
            }],
    }, {
        text: 'About Us',
        url: null,
        sitemapItems: [{
                text: 'Our Story',
                url: 'https://devnew.okay.com/en/about-us',
                sitemapItems: null,
            }, {
                text: 'Our Team',
                url: null,
                sitemapItems: [{
                        text: 'Executive Team',
                        url: 'https://devnew.okay.com/en/property-experts',
                        sitemapItems: null,
                    }, {
                        text: 'Property Agents',
                        url: 'https://devnew.okay.com/en/property-agent-team',
                        sitemapItems: null,
                    }],
            }, {
                text: 'Testimonials',
                url: 'https://devnew.okay.com/en/about-us/testimonials',
                sitemapItems: null,
            }, {
                text: 'In the press',
                url: 'https://dev.okay.com/en/about-us/in-the-press',
                sitemapItems: null,
            }, {
                text: 'Investors',
                url: 'https://devnew.okay.com/en/about-us/investors',
                sitemapItems: null,
            }, {
                text: 'Contact Us',
                url: 'https://dev.okay.com/en/communication/enquiry',
                sitemapItems: null,
            }],
    }, {
        text: 'Careers',
        url: null,
        sitemapItems: [{
                text: 'Careers',
                url: 'https://devcareers.okay.com/en-US',
                sitemapItems: null,
            }],
    }
];
